// src/ModalPortal.tsx
import { type ReactNode } from 'react';
import type React from 'react';

import ReactDOM from 'react-dom';


interface ModalPortalProperties {
  children: ReactNode;
}

export const ModalPortal: React.FC<ModalPortalProperties> = ({ children }) => {
  const modalRoot = document.querySelector('#modal-root');

  if (!modalRoot) {
    throw new Error("The 'modal-root' element is not found in the document.");
  }

  return ReactDOM.createPortal(children, modalRoot);
};
